import type {
  IOnboardingCompleteWizardBody,
  IOnboardingCompleteWizardRequest,
  IOnboardingCompleteWizardResponse,
} from '@/app-package';

import axios from 'axios';

const completeWizard = async (body: IOnboardingCompleteWizardBody) => {
  const url = '/onboarding/complete_wizard';

  const config: IOnboardingCompleteWizardRequest = {
    url,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IOnboardingCompleteWizardResponse>(config);

  return data;
};

export default completeWizard;
